import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import {Theme} from "@emotion/react";

const useStyles = makeStyles<Theme, {bold: boolean}>((theme) => ({
    text: {
        fontFamily: "inherit",
        fontSize: "inherit",
        fontWeight: (props) => props.bold ? "bold" : "inherit",
        marginLeft: "5mm",
        marginRight: "5mm"
    }
}));

interface Props
{
    bold?: boolean
    text: string
}

export default function MarginLabel({ bold, text }: Props)
{
    const classes = useStyles({bold: bold || false});

    return <Typography className={classes.text} component="span">{text}</Typography>
}